import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-left font-bold text-2xl" }, "Dados Profissionais"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm text-gray-500" }, "Seu CRM será validado pelo sistema do CFM.")
], -1)
const _hoisted_2 = { class: "flex flex-col w-full gap-2" }

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useDoctorRegistryStore } from '@/pinia-store/useDoctorRegistryStore'
import ufs from '@/config/StatesFromBR'
import { rules } from '@/utils/rules'
import { getCfmLookupFailure, getCfmUnavailableMessage } from '@/utils/cfmLookupErrors'
import Network from '@/Network'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionalData',
  setup(__props) {

const doctorRegistryStore = useDoctorRegistryStore()
const { professionalDataForm, professionalDataFormRef } = storeToRefs(doctorRegistryStore)

const cfmResponse = ref<string | null>(null)
const isLoadingCfm = ref(false)

const searchCrm = async () => {
  cfmResponse.value = ''
  professionalDataForm.value.name = ''
  if (!professionalDataForm.value.crm || !professionalDataForm.value.crmUf) return
  const crm = `${professionalDataForm.value.crm}/${professionalDataForm.value.crmUf}`

  try {
    isLoadingCfm.value = true
    const data = await Network.cfm.validateCrm({
      crm: professionalDataForm.value.crm,
      crmUf: professionalDataForm.value.crmUf
    })

    if (data.status !== 'Ativo') {
      cfmResponse.value = `CRM: ${crm} não está ativo no CFM`
      return
    }
    professionalDataForm.value.name = data.name
    cfmResponse.value = ''
  } catch (error) {
    // CFM fora do ar NÃO pode virar "CRM já em uso": o médico precisa saber
    // que basta tentar de novo (ver `getCfmLookupFailure`).
    const failure = getCfmLookupFailure(error)
    if (failure === 'not_found') {
      cfmResponse.value = `CRM: ${crm} não encontrado no CFM`
    } else if (failure === 'already_linked') {
      cfmResponse.value = `CRM: ${crm} já está sendo utilizado no sistema`
    } else if (failure === 'invalid_input') {
      cfmResponse.value = 'Verifique o número do CRM e o estado informados.'
    } else {
      cfmResponse.value = getCfmUnavailableMessage(error)
    }
  } finally {
    isLoadingCfm.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_v_form, {
    ref_key: "professionalDataFormRef",
    ref: professionalDataFormRef,
    id: "formDoctorSignUpPesonalData",
    class: "w-full flex gap-7 items-center flex-col rounded overflow-hidden mt-5 mb-4"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createBlock(_component_v_text_field, {
          modelValue: _unref(professionalDataForm).crm,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_unref(professionalDataForm).crm) = $event)),
            searchCrm
          ],
          label: "* CRM",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          error: !!cfmResponse.value,
          rules: [_unref(rules).required],
          "validate-on": "lazy input"
        }, {
          loader: _withCtx(() => [
            _createVNode(_component_v_progress_linear, {
              active: isLoadingCfm.value,
              color: "primary",
              height: "7",
              indeterminate: ""
            }, null, 8, ["active"])
          ]),
          _: 1
        }, 8, ["modelValue", "error", "rules"])), [
          [_directive_maska, '######']
        ]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _unref(professionalDataForm).crmUf,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_unref(professionalDataForm).crmUf) = $event)),
            searchCrm
          ],
          label: "* Estado",
          color: "primary",
          error: !!cfmResponse.value,
          variant: "outlined",
          items: _unref(ufs),
          rules: [_unref(rules).required, _unref(rules).uf, _unref(rules).ufLen]
        }, {
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              title: item?.raw?.value,
              subtitle: item?.raw?.title
            }), null, 16, ["title", "subtitle"])
          ]),
          _: 1
        }, 8, ["modelValue", "error", "items", "rules"]),
        _createVNode(_component_v_text_field, {
          modelValue: _unref(professionalDataForm).name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(professionalDataForm).name) = $event)),
          label: "* Nome",
          class: "w-full",
          color: "primary20",
          variant: "outlined",
          disabled: ""
        }, null, 8, ["modelValue"]),
        (cfmResponse.value)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              text: cfmResponse.value,
              type: "error"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}
}

})